import { HAVEN_EXTENSION_IDS } from '@trusty/shared';

// Sourced from the single home for Haven's build IDs (@trusty/shared, ENG-2435) — not hand-copied.
export const PRODUCTION_EXTENSION_ID = HAVEN_EXTENSION_IDS.PROD;
export const CANARY_EXTENSION_ID = HAVEN_EXTENSION_IDS.CANARY;
// ENG-2439: the continuous Edge canary build's fixed id (packages/haven-extension/manifest.edge.json).
export const EDGE_CANARY_EXTENSION_ID = HAVEN_EXTENSION_IDS.EDGE_CANARY;
// ENG-3911: the Edge Add-ons production listing's id, minted by Partner Center.
export const EDGE_EXTENSION_ID = HAVEN_EXTENSION_IDS.EDGE;

export const ALLOWED_EXTENSION_IDS = new Set([
  PRODUCTION_EXTENSION_ID,
  CANARY_EXTENSION_ID,
  EDGE_CANARY_EXTENSION_ID,
  EDGE_EXTENSION_ID,
  ...(process.env.REACT_APP_DEV_EXTENSION_ID ? [process.env.REACT_APP_DEV_EXTENSION_ID] : []),
]);

export function isValidExtensionId(id: string | null | undefined): id is string {
  if (!id) return false;
  if (!/^[a-z]{32}$/.test(id)) return false;
  return ALLOWED_EXTENSION_IDS.has(id);
}

export { CHROME_WEB_STORE_URL as CHROME_STORE_URL } from '@trusty/shared';

// ENG-3147: gate the "Continue with Microsoft" button behind an env var. On for alpha (ENG-3892)
// and prod; off for dev and local unless set.
// CRA only inlines vars prefixed REACT_APP_ and only at build time — this can't be flipped at
// runtime, so alpha/prod need separate builds (see deploy:alpha / deploy in package.json).
export const MICROSOFT_LOGIN_ENABLED = process.env.REACT_APP_ENABLE_MICROSOFT_LOGIN === 'true';

// Gate the "Continue with Apple" button behind an env var while the Apple Services ID +
// Sign in with Apple key are still being validated in the Firebase console, so it can ship
// to alpha without appearing on prod. Same CRA build-time-inline constraint as Microsoft
// above — alpha/prod need separate builds.
export const APPLE_LOGIN_ENABLED = process.env.REACT_APP_ENABLE_APPLE_LOGIN === 'true';

// ENG-3468: the one support address. It was written out by hand in each place that offered it.
export const SUPPORT_EMAIL = 'support@starthaven.com';
